import React, { useContext } from 'react'
import styled from 'styled-components'
import { 
    Container,
    HeaderDiv,
    HeaderText,
    CloseDiv,
    CloseImg, // Mantido conforme solicitado
    OptionTabDiv,
    OptionTextDiv,
    OptionMainText,
    OptionSubText,
    ArrowImg,
    CancelButton
 } from './style' 
import ModalContext from '../../contexts/ModalContext'

// Importando os assets que você já confirmou que existem
import cross from '../../assets/addStockModal/cross.svg'
import arrow from '../../assets/addStockModal/arrow-right.svg'

// Ícones do Lucide para as opções internas (substituindo arquivos físicos inexistentes)
import { FileText, ShieldCheck, Mail, Truck, Briefcase } from 'lucide-react'
import { useNavigate } from 'react-router-dom'

// Container para os ícones coloridos
const IconBox = styled.div<{ bgColor: string }>`
  width: 40px;
  height: 40px;
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  background-color: ${props => props.bgColor};
`;

const EmitInvoiceModal: React.FC = () => {
  const { setModalActive } = useContext(ModalContext)
  const navigate = useNavigate()

  const invoiceOptions = [
    {
      id: 'nfe',
      title: 'NF-e — Nota Fiscal Eletrônica de Produto',
      sub: 'Venda, transferência ou devolução de mercadorias. Modelo 55.',
      icon: <FileText size={20} color="#0085CC" />, 
      bgColor: '#E6F3FA'
    },
    {
      id: 'nfse',
      title: 'NFS-e — Nota Fiscal de Serviço',
      sub: 'Prestação de serviços sujeitos ao ISS municipal.',
      icon: <ShieldCheck size={20} color="#00B37E" />, 
      bgColor: '#E6F9F1'
    },
    {
      id: 'nfe_ind',
      title: 'NF-e de Industrialização',
      sub: 'Remessa para industrialização / retorno de industrialização.',
      icon: <Mail size={20} color="#FFB800" />, 
      bgColor: '#FFF7E6'
    },
    {
      id: 'cte',
      title: 'CT-e — Conhecimento de Transporte Eletrônico',
      sub: 'Prestação de serviços de transporte. Modelo 57.',
      icon: <Truck size={20} color="#0085CC" />, 
      bgColor: '#E6F3FA'
    },
    {
      id: 'mdfe',
      title: 'MDF-e — Manifesto de Documentos Fiscais',
      sub: 'Documento obrigatório para veículos em trânsito com carga.',
      icon: <Briefcase size={20} color="#996DFF" />, 
      bgColor: '#F2EEFF'
    }
  ]

  const handleSelectOption = (id: string) => {
    if (id === 'nfe') {
      // 3. Fecha o modal antes de navegar
      setModalActive(false) 
      
      // 4. Navega para a rota que você definiu
      navigate('/panel/invoice/create') 
    } else {
      console.log(`Outras opções ainda não implementadas: ${id}`)
    }
  }

  return (
    <Container style={{ maxHeight: '90vh', overflowY: 'auto' }}>
      <HeaderDiv>
        <div style={{ display: 'flex', flexDirection: 'column', gap: '4px' }}>
            <HeaderText>Emitir nota fiscal</HeaderText>
            <OptionSubText>Selecione o tipo de documento fiscal</OptionSubText>
        </div>
        <CloseDiv onClick={() => setModalActive(false)}>
          <CloseImg src={cross} alt='Fechar' />
        </CloseDiv>
      </HeaderDiv>

      <div style={{ 
        display: 'flex', 
        flexDirection: 'column', 
        marginTop: '16px',
        width: '100%',
        maxWidth: '31vw' // Mesma largura do HeaderDiv no seu styled
      }}>
        {invoiceOptions.map((option) => (
          <OptionTabDiv key={option.id} onClick={() => handleSelectOption(option.id)}>
            <IconBox bgColor={option.bgColor}>
              {option.icon}
            </IconBox>
            
            <OptionTextDiv>
              <OptionMainText>{option.title}</OptionMainText>
              <OptionSubText>{option.sub}</OptionSubText>
            </OptionTextDiv>
            
            <ArrowImg src={arrow} alt='Seta' />
          </OptionTabDiv>
        ))}
      </div>

      <CancelButton onClick={() => setModalActive(false)}>Cancelar</CancelButton>
    </Container>
  )
}

export default EmitInvoiceModal